import { createSelector } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectExperiments } from 'shared/selectors/experiments/selectExperiments';
import { isExperimentActive } from 'shared/utils/experiments';

export const useExperiment = (experimentName: string, groupName = 'B') => {
  const isExperimentEnabledSelector = useCallback(
    createSelector([selectExperiments], experiments => isExperimentActive(experiments, experimentName, groupName)),
    [experimentName, groupName],
  );

  return useSelector(isExperimentEnabledSelector);
};
